import {
  beFiltersApiCreateFilter,
  beFiltersApiDeleteFilter,
  beFiltersApiGetCategoryById,
  beFiltersApiGetEntitiesUsingFilter,
  beFiltersApiGetFilter,
  beFiltersApiSearchFilters,
} from 'Api/beFiltersApi'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  storeGet,
} from 'mailup-react-helpers'
import { LoginTypeEnum } from 'Providers/AuthProvider'
import {
  type BeFilterSummaryResponse,
  type Category,
  type FilterDetail,
  type PagedList,
} from 'Types/beFiltersApi'
import getIntl from '../../../helpers/intl'
import { type SearchState } from '../state/state'
import { getFilterTypes } from './filterTypes'

export const getSearchFilters = async ({
  allCategories,
  allTypes,
  ...query
}: SearchState): Promise<PagedList<BeFilterSummaryResponse>> => {
  const idList = storeGet(STORE_KEY_ID_LIST) as number
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType === (LoginTypeEnum as any).AdmLogin.ordinal ||
    loginType === (LoginTypeEnum as any).AdmLoginLimited.ordinal
      ? undefined
      : false
  const completeQuery = { ...query, hidden }
  if (allCategories) {
    completeQuery.categories = []
  }
  if (allTypes || query.types.length === 0) {
    completeQuery.types = getFilterTypes().map((t) => t.value)
  }
  return await beFiltersApiSearchFilters(completeQuery, idList)
}

export const getCategory = async (id: number): Promise<Category> => {
  return await beFiltersApiGetCategoryById(id)
}

export const deleteFilter = async (idFilter: number): Promise<void> => {
  await beFiltersApiDeleteFilter(idFilter)
}

export const getEntitiesUsingFilter = beFiltersApiGetEntitiesUsingFilter

export const copyFilter = async (id: number): Promise<FilterDetail> => {
  const intl = getIntl()
  const copyOf = intl.formatMessage({ id: 'Load.Common.Copyof' })
  const filterToCopy = await beFiltersApiGetFilter(id)
  filterToCopy.Description = `${copyOf} ${filterToCopy.Name}`
  filterToCopy.CustomDescription = true
  return await beFiltersApiCreateFilter(filterToCopy)
}
